// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "@reach/router";
import PageHeader from "../../../components/PageHeader";
import PageTitle from "../../../components/PageTitle";
import PageBody from "../../../components/PageBody";
import ThematicDossierForm from "./ThematicDossierForm";
import { AuthentifiedUser } from "../../../../api/backend-openapi";
import { useStore } from "effector-react";
import { authentifiedUserStore } from "../../../../state/auth/AuthStore";
import { NboAction } from "../../../types/AuthTypes";

interface ThematicDossierEditProps extends RouteComponentProps {
  thematicDossierId?: string;
}

const ThematicDossierScreen: React.FunctionComponent<ThematicDossierEditProps> = (
  props: ThematicDossierEditProps
) => {
  const { t } = useTranslation();
  const authentifiedUser: AuthentifiedUser | null = useStore(
    authentifiedUserStore
  );
  const canEdit: boolean =
    authentifiedUser?.rights.nboThematicDossier?.includes(
      NboAction.nboUpdate
    ) || false;
  const canDelete: boolean =
    authentifiedUser?.rights.nboThematicDossier?.includes(
      NboAction.nboDelete
    ) || false;
  const canValidate: boolean =
    authentifiedUser?.rights.nboThematicDossier?.includes(
      NboAction.nboValidate
    ) || false;

  const [editMode, setEditMode] = useState<boolean>(false);
  const { thematicDossierId } = props;

  return (
    <>
      <PageHeader>
        <PageTitle
          title={t(
            editMode
              ? "thematic_dossier.edit_title"
              : "thematic_dossier.detail_title"
          )}
        />
      </PageHeader>
      <PageBody>
        <ThematicDossierForm
          thematicDossierId={thematicDossierId ? thematicDossierId : ""}
          editMode={editMode}
          setEditMode={setEditMode}
          canEdit={canEdit}
          canDelete={canDelete}
          canValidate={canValidate}
        />
      </PageBody>
    </>
  );
};

export default ThematicDossierScreen;
